import { endSession, getAccessToken } from '../auth/session';
import { staffGet } from './client';
import { request } from './http';
import type {
  GoogleSignInResponse,
  MfaEnrollResponse,
  StaffMe,
  TokenPair,
} from './types';

// The /auth/* calls handle their own errors: a wrong code is a 401 the form
// shows, not a signal that the session ended. Only staffGet does that.

export const signInWithGoogle = (idToken: string) =>
  request<GoogleSignInResponse>('/v1/staff/auth/google', {
    method: 'POST',
    body: { id_token: idToken },
  });

export const enrollMfa = (pendingToken: string, enrolCode: string) =>
  request<MfaEnrollResponse>('/v1/staff/auth/mfa/enroll', {
    method: 'POST',
    body: { enrol_code: enrolCode },
    token: pendingToken,
  });

export const verifyMfa = (pendingToken: string, code: string) =>
  request<TokenPair>('/v1/staff/auth/mfa/verify', {
    method: 'POST',
    body: { code },
    token: pendingToken,
  });

export const fetchMe = () => staffGet<StaffMe>('/v1/staff/auth/me');

/** Tells the server, then drops the tokens whether or not the call worked. */
export async function logout() {
  try {
    await request('/v1/staff/auth/logout', {
      method: 'POST',
      token: getAccessToken(),
    });
  } finally {
    endSession();
  }
}
